const trailbalance = { data: [], loading: true };
export const GetTrailBalance = (state = trailbalance, action) => {
    switch (action.type) {

        case "get_alltrailbalance":
            return {
                data: action.payload,
                loading: action.loading
            }
        default:
            return state;
    }


}